// The chat launchers (Chatwoot bubble, the cookie banner's chat button shown before Chatwoot loads,
// the AI assistant) are fixed bottom-right above every Vuetify overlay, so on a phone they cover
// the buttons of a dialog or bottom sheet. While any of those is open the launchers are hidden.
// A chat window the user already opened stays: the Chatwoot bubble is its close button, and the
// AI assistant's host carries its open panel (and the page push of its docked mode).
const OPEN_DIALOG = ".v-dialog__content--active";

export const CHAT_LAUNCHERS_HIDDEN = "cd-chat-launchers-hidden";

const STYLE = [
  `body.${CHAT_LAUNCHERS_HIDDEN} #cw-bubble-holder`,
  `body.${CHAT_LAUNCHERS_HIDDEN} #cd-chat-button`,
  `calendesk-ai-assistant.${CHAT_LAUNCHERS_HIDDEN}`,
]
  .join(", ")
  .concat(" { display: none !important; }");

export function syncChatLaunchers() {
  const dialogOpen = !!document.querySelector(OPEN_DIALOG);
  document.body.classList.toggle(
    CHAT_LAUNCHERS_HIDDEN,
    dialogOpen && !window.$chatwoot?.isOpen,
  );
  document.querySelectorAll("calendesk-ai-assistant").forEach((el) => {
    el.classList.toggle(CHAT_LAUNCHERS_HIDDEN, dialogOpen && !el.isOpen);
  });
}

// Called once at app start.
export function watchChatLaunchers() {
  const style = document.createElement("style");
  style.textContent = STYLE;
  document.head.appendChild(style);

  new MutationObserver(syncChatLaunchers).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["class"],
  });
  syncChatLaunchers();
}
